export const routeBase = "/Prospectos/";

export const routeRoot = "/";
export const routeEdit = "/editar-solicitud";
